import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { shopifyService } from '../services/shopifyService';

export const ShopifyCallback: React.FC = () => {
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const [processed, setProcessed] = useState(false);

  useEffect(() => {
    const handleCallback = async () => {
      try {
        // Verificar se o callback já foi processado
        if (processed) {
          console.log('Callback já foi processado, ignorando');
          return;
        }

        // Marcar como processado para evitar múltiplas tentativas
        setProcessed(true);

        // Verificar se o utilizador está autenticado
        if (!currentUser?.companyId) {
          throw new Error('Utilizador não autenticado ou sem empresa associada');
        }

        const params = new URLSearchParams(window.location.search);
        const code = params.get('code');
        const shop = params.get('shop');
        const state = params.get('state');
        const hmac = params.get('hmac');

        console.log('Parâmetros recebidos:', {
          code,
          shop,
          state,
          hmac,
          currentCompanyId: currentUser.companyId
        });

        // Validar parâmetros obrigatórios
        if (!code || !shop || !hmac) {
          throw new Error(`Parâmetros em falta na URL de callback: ${JSON.stringify({
            code: !!code,
            shop: !!shop,
            hmac: !!hmac
          })}`);
        }

        // Validar o state (deve ser igual ao companyId)
        if (state !== currentUser.companyId) {
          throw new Error(`Estado inválido na resposta do Shopify. Esperado: ${currentUser.companyId}, Recebido: ${state}`);
        }

        // Trocar o código por um token de acesso
        await shopifyService.exchangeCodeForToken(code, shop, currentUser.companyId, hmac);
        
        // Redirecionar para a página de configurações
        navigate('/dashboard/integrations/settings');
      } catch (error) {
        console.error('Erro detalhado no callback do Shopify:', error);
        navigate('/dashboard/integrations/settings', { 
          state: { error: error instanceof Error ? error.message : 'Erro desconhecido' } 
        });
      }
    };

    handleCallback();
  }, [navigate, currentUser, processed]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="p-8 bg-white rounded-lg shadow-md">
        <h1 className="text-2xl font-bold mb-4">Autenticando com o Shopify...</h1>
        <p className="text-gray-600">Por favor, aguarde enquanto processamos a autenticação.</p>
      </div>
    </div>
  );
};

export default ShopifyCallback;
